// TSS vite/04 §"Endpoint paths". Relativos, sin slash inicial: el baseURL ya
// incluye /api/v1. Dominio SG (Software Ganadero, admin-sg.md).

export const sgPaths = {
    cows:      ()   => 'admin/sg/cows',
    cow:       (id) => `admin/sg/cows/${id}`,
    cowEvents: (id) => `admin/sg/cows/${id}/events`,
    backups:   ()   => 'admin/sg/backups',   // POST de subida del .zip (D-002)
};
